import api from './api';
import axios from 'axios';
import { constURL } from './enum.services';
import { createAsyncThunk } from '@reduxjs/toolkit';
import jwt_decode from 'jwt-decode';

export interface AccountInterface {
  login: string;
  password: string;
  role?: string;
  name?: string;
}

export interface objAuthI {
  id: string;
  token: string;
}

export const decodeToken = (token: string | null) => {
  if (!token) return '';
  const result = jwt_decode(token);
  // @ts-ignore
  return result.data;
};

export const checkAuth = createAsyncThunk(
  'user/checkAuth',
  async (objAuth: objAuthI, { rejectWithValue }) => {
    try {
      const response = await api.post(constURL.LOGIN, objAuth);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.status);
        // console.log(`errorAuth: ${(error.response.data as ErrorResponse).message}`);
        // throw (error.response.data as ErrorResponse).message;
      }
      throw error;
    }
  }
);

export const login = createAsyncThunk(
  'user/login',
  async (objUser: AccountInterface, { rejectWithValue }) => {
    try {
      if (!localStorage.getItem('dataPortal')) {
        const response = await api.post(constURL.LOGIN, objUser);
        localStorage.setItem('dataPortal', JSON.stringify(response.data));
        return response.data;
      }
      // return response.data.token;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.status);
      }
      throw error;
    }
  }
);
